import { render, staticRenderFns } from "./SearchTopBar.vue?vue&type=template&id=641fc40c&scoped=true&"
import script from "./SearchTopBar.vue?vue&type=script&lang=js&"
export * from "./SearchTopBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchTopBar.vue?vue&type=style&index=0&id=641fc40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fc40c",
  null
  
)

export default component.exports